import { Component, OnInit } from '@angular/core';
import { forkJoin } from 'rxjs';
import { FeaturesBaseComponent } from 'src/app/features-common/components/features-base.component';
import { MessagesService } from './messages.service';

@Component({
  selector: 'app-messages-smart',
  template: `<app-messages [allrecipients]="allrecipients" [receivedMessages]="receivedMessages"></app-messages>
  `,
  styles: [
  ]
})
export class MessagesSmartComponent extends FeaturesBaseComponent implements OnInit {
  allrecipients: any = [];
  receivedMessages : any = [];

  constructor(private messagesService: MessagesService) {
    super();
    this.getAllData()
  }
  getAllData() {
    // get all business name details
    let allUserlist = this.messagesService.getAllUserList();
    let receivedMessages = this.messagesService.getReceivedMessages();

    forkJoin([allUserlist,receivedMessages]).subscribe( res => {
      this.allrecipients  = res[0]['httpcode'] == 200 ? res[0]['data'] : [];
      this.receivedMessages = res[1]['httpcode'] == 200 ? res[1]['data'] : [];
    })

  }

  ngOnInit(): void {
    super.ngOnInit()
  }

  ngOnDestroy(){
    super.ngOnDestroy()
  }

}


